export default __webpack_public_path__ + "static/media/icon-twitter.174a2a6a.svg";